import isFunction from '../isFunction'

const postorderTraverser = ({ getChildren, visit }) => {
  if (!isFunction(visit) || !isFunction(getChildren)) {
    throw new Error(
      'postorderTraverser requires visit and getChildren functions'
    )
  }
  const traverse = (node) => {
    const children = getChildren(node) || []
    children.forEach((child) => traverse(child))
    visit(node)
  }
  return traverse
}

export default postorderTraverser
